/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CalendarEventTypeDto { 
    /**
     * Id del tipo de evento
     */
    id: string;
    /**
     * Nombre del tipo tal cual está en BD
     */
    name: string;
    /**
     * Nombre a mostrar (p. ej. \"Aniversario Avalanz\")
     */
    label: string;
    /**
     * Color hexadecimal del tipo
     */
    color: string;
    /**
     * Nombre de PrimeIcon sin el prefijo \"pi-\"
     */
    icon: string;
}

